import { takeLatest, put } from 'redux-saga/effects';

import {
    CANCEL_FUNCIONARIO_CADASTRO_RAPIDO,
    CANCEL_FUNCIONARIO_CADASTRO_RAPIDO_SUCCESS
} from '../actionTypes';

function* sagaCancelFuncionarioCadastroRapido() {
  yield put({ type: CANCEL_FUNCIONARIO_CADASTRO_RAPIDO_SUCCESS})
}

export default function* watchCancelFuncionarioCadastroRapido() {
  yield takeLatest(CANCEL_FUNCIONARIO_CADASTRO_RAPIDO, sagaCancelFuncionarioCadastroRapido)
}